import classNames from 'classnames'

import { useElementSize } from '@hooks/useElementSize'

import styles from './TableNoResults.module.scss'

export const TableEmptyComponent = () => {
  const { ref, size } = useElementSize<HTMLDivElement>()

  const isCompact = size.width < 768

  const rows = 3
  const bigColumns = isCompact ? 1 : 2
  const smallColumns = isCompact ? 2 : 3

  return (
    <div ref={ref} className={styles.emptyState}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div className={styles.row} key={rowIndex}>
          {Array.from({ length: bigColumns }).map((_, index) => (
            <div className={styles.cell} key={`big-${index}`}>
              <div className={styles.box} />
              <div className={classNames(styles.bar, styles.wide)} />
            </div>
          ))}
          {Array.from({ length: smallColumns }).map((_, index) => (
            <div className={styles.cell} key={`small-${index}`}>
              <div className={styles.bar} />
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
